export default __webpack_public_path__ + "static/media/c6.bbbda4ed.png";